import { useResponsiveWidth } from '@/hooks/useResponsiveDimensions';
import { useEffect, useState } from 'react';
import { StyleSheet, TouchableHighlight } from 'react-native';
import { Text } from '@/components/Text';
import colors from '@/config/colors';

const styles = StyleSheet.create({
  choiceButton: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

function TextGapWritingChoiceButton(props) {
  // eslint-disable-next-line
  const [backgroundColorRed, setBackgroundColorRed] = useState(colors.white);
  const [textColorWhite, setTextColorWhite] = useState(colors.black);
  const [timeoutHandler, setTimeoutHandler] = useState(null);

  useEffect(() => {
    // on component unmount destroy timeout
    return () => {
      if (timeoutHandler) {
        clearTimeout(timeoutHandler);
      }
    };
  }, []);

  const responsiveStyles = StyleSheet.create({
    shadow2: {
      shadowColor: '#000',
      shadowRadius: useResponsiveWidth(0.3),
      shadowOffset: {
        width: useResponsiveWidth(0.1),
        height: useResponsiveWidth(0.1),
      },
      shadowOpacity: 0.25,
      elevation: 3,
    },
    choiceButton: {
      marginHorizontal: props.choiceFontSize / 2,
      paddingHorizontal: props.choiceFontSize / 2,
      paddingVertical: props.choiceFontSize / 8,
      marginBottom: props.choiceFontSize / 8,
    },
    fontSize: {
      fontSize: props.choiceFontSize,
    },
    styleObj: {
      backgroundColor: backgroundColorRed,
      opacity: props.solved
        ? props.showOnlyTheCorrectAnswer === props.word
          ? 1
          : 0
        : 1,
    },
  });

  return (
    <TouchableHighlight
      underlayColor={props.correctChoice ? colors.primary : colors.red}
      style={[
        styles.choiceButton,
        responsiveStyles.shadow2,
        responsiveStyles.choiceButton,
        responsiveStyles.styleObj,
      ]}
      onPressIn={function () {
        setTextColorWhite(colors.white);
        if (!props.correctChoice) {
          setBackgroundColorRed(colors.red);
          setTextColorWhite(colors.white);
          setTimeoutHandler(
            setTimeout(function () {
              setBackgroundColorRed(colors.white);
              setTextColorWhite(colors.black);
            }, 1000),
          );
        } else {
          setBackgroundColorRed(colors.primary);
          setTextColorWhite(colors.white);
          setTimeoutHandler(
            setTimeout(function () {
              setBackgroundColorRed(colors.white);
              setTextColorWhite(colors.black);
            }, 3000),
          );
          props.choiceSelected();
        }
      }}
    >
      <Text style={[responsiveStyles.fontSize, { color: textColorWhite }]}>
        {props.word}
      </Text>
    </TouchableHighlight>
  );
}

export default TextGapWritingChoiceButton;
